export function getLocationUrl(location: Location): URL {
  const { protocol, host, pathname, search } = location;

  return new URL(`${protocol}//${host}/${pathname}${search ?? ''}`);
}
